export enum OnboardingSubstatus {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  INTAKE_SCHEDULED = "INTAKE_SCHEDULED",
}

export enum ReferredOutReason {
  ACUITY = "ACUITY",
  SPECIALIZED_CARE = "SPECIALIZED_CARE",

  AGE = "AGE",
  LANGUAGE = "LANGUAGE",
  OTHER = "OTHER",
  ATTENDANCE_POLICY = "ATTENDANCE_POLICY",
  // Insurance related reasons
  INSURANCE = "INSURANCE", // This means "OON Insurance" -- TODO: rename to OON_INSURANCE
  // Deprecated for new writes: overlaps with INELIGIBLE_INSURANCE without
  // adding signal. Kept for backward-compatible display + read paths
  // (`isStillReferredOutForReason`, gating-flow `appliesTo` lists,
  // `referredOrOptedOut`'s INELIGIBLE-or-INACTIVE handler) so legacy
  // rows still surface correctly. New refer-outs use INELIGIBLE_INSURANCE.
  INACTIVE_INSURANCE = "INACTIVE_INSURANCE",
  INELIGIBLE_INSURANCE = "INELIGIBLE_INSURANCE",
  // Deprecated: kept for backward-compatible display of historical records
  DISCHARGED = "DISCHARGED",
  HEADWAY_SETUP_INCOMPLETE = "HEADWAY_SETUP_INCOMPLETE",
}

export enum OptOutReasonV2 {
  COPAY = "COPAY",
  NO_LONGER_INTERESTED = "NO_LONGER_INTERESTED",
  RESISTANCE_TO_VIRTUAL = "RESISTANCE_TO_VIRTUAL",
  ALREADY_IN_CARE = "ALREADY_IN_CARE",
  RELOCATED_OUT_OF_SERVICE_AREA = "RELOCATED_OUT_OF_SERVICE_AREA",
  OTHER = "OTHER",
  RESISTANCE_TO_THERAPY_GUARDIAN = "RESISTANCE_TO_THERAPY_GUARDIAN",
  RESISTANCE_TO_THERAPY_STUDENT = "RESISTANCE_TO_THERAPY_STUDENT",
  // Deprecated: kept for backward-compatible display of historical records
  ATTENDENCE_POLICY = "ATTENDENCE_POLICY", // moved to ReferredOutReason as ATTENDANCE_POLICY
  NON_RESPONSIVE = "NON_RESPONSIVE", // promoted to top-level StudentStatus
  NO_LONGER_NEEDS_THERAPY = "NO_LONGER_NEEDS_THERAPY", // promoted to top-level CARE_COMPLETED status
  CARE_CONCLUDED = "CARE_CONCLUDED", // promoted to top-level CARE_COMPLETED status
  RESISTANCE_TO_THERAPY = "RESISTANCE_TO_THERAPY",
  RESISTANCE_TO_VIRTUAL_GUARDIAN = "RESISTANCE_TO_VIRTUAL_GUARDIAN",
  RESISTANCE_TO_VIRTUAL_STUDENT = "RESISTANCE_TO_VIRTUAL_STUDENT",
}
